<div class="app-table-wrapper">
  <ng-container *ngIf="isLoading; else loadedview">
    <div class="app-table-inital-loading-container">
      <i class="fas fa-spinner fa-spin loading-table-overlay-spinner"></i>
    </div>
  </ng-container>
  <ng-template #loadedview>
    <div
      class="app-table-top-row"
      *ngIf="canSearch || showPaginator || createText || customCountLabel"
    >
      <div class="app-table-searchs-container">
        <ng-content select="[table-top-row-left]"></ng-content>
        <ng-content select="[table-search]"></ng-content>
        <div
          class="app-table-search-container"
          *ngIf="canSearch || showPaginator || customCountLabel"
        >
          <div class="inline-label" *ngIf="canSearch && searchByOptions?.length">
            <label class="table-header app-label-table">{{ "search_by" | translation }}</label>

            <p-select
              [(ngModel)]="searchBy"
              [options]="searchByOptions"
              optionLabel="translation_key"
              optionValue="value"
              [placeholder]="'search_by' | translation"
              style="width: 120px"
              (onChange)="handleUpdateSearchBy($event)"
            >
              <ng-template #selectedItem let-selectedOption>
                {{
                  selectedOption.translation_key || selectedOption.label
                    | translation
                    | transformText : "capitalize"
                }}
              </ng-template>

              <ng-template let-op #item>
                {{
                  op.translation_key || op.label
                    | translation
                    | transformText : "capitalize"
                }}
              </ng-template>
            </p-select>
          </div>
          <div class="app-table-search-field" *ngIf="canSearch">
            <p-inputgroup>
              <input
                class="app-table-search-input"
                (keyup.enter)="handleInitSearch()"
                pInputText
                [placeholder]="'search' | translation"
                type="text"
                [(ngModel)]="filterInput"
              />
              <p-inputgroup-addon *ngIf="filterInput">
                <p-button
                  [variant]="'text'"
                  severity="contrast"
                  (click)="handleInitSearch(true)"
                  type="button"
                  [pTooltip]="'clear_search' | translation"
                  tooltipPosition="top"
                >
                  <i class="fa-thin fa-xmark"></i>
                </p-button>
              </p-inputgroup-addon>
              <p-inputgroup-addon>
                <p-button
                  [variant]="'text'"
                  severity="contrast"
                  (click)="handleInitSearch()"
                  type="button"
                >
                  <i class="fa-thin fa-magnifying-glass"></i>
                </p-button>
              </p-inputgroup-addon>
            </p-inputgroup>
          </div>

          <ng-content select="[additional-filters]"></ng-content>

          <span
            [style.color]="'#747d88'"
            *ngIf="customCountLabel"
            class="app-table-top-row-count-label"
            >{{ customCountLabel }}</span
          >

          <div *ngIf="showPaginator" class="app-table-item-per-page-container">
            <label class="app-label-table">{{ "items_per_page" | translation }}:</label>
            <p-select
              [(ngModel)]="perPage"
              [options]="perPageOptions"
              optionLabel="count"
              optionValue="count"
              [placeholder]="'per_page' | translation"
              (onChange)="handleSetPageCount($event)"
            >
            </p-select>
          </div>
          <span
            *ngIf="itemCount && showPaginator"
            class="app-table-top-row-count-label"
            >{{ getCountLabel() }}</span
          >
        </div>
        <ng-content select="[table-top-row-right]"></ng-content>
      </div>
      <div
        class="app-table-add-button-wrapper"
        *ngIf="createText && showCreate"
      >
        <p-button
          [variant]="'text'"
          severity="link"
          (click)="handleCreateClicked()"
          class="app-table-add-button"
        >
          <i class="fa fa-plus"></i>
          <div class="button-content">{{ createText | translation }}</div>
        </p-button>
      </div>
    </div>

    <!-- {{'course_title'|translation}} -->

    <ng-container *ngIf="!rows?.length && emptyText; else tableview">
      <label class="app-table-empty-text font-family-1">{{ emptyText }}</label>
    </ng-container>
    <ng-template #tableview>
      <div class="loading-table-wrapper">
        <div
          class="loading-table-overlay-spinner-container"
          *ngIf="isProcessing"
        >
          <i class="fas fa-spinner fa-spin loading-table-overlay-spinner"></i>
        </div>
        <div [ngClass]="{ 'loading-table-overlay': isProcessing }">
          <div
            class="app-table-container"
            [style.max-height]="maxHeight"
            [style.overflow-y]="'auto'"
          >
            <!-- use virtual scroll table-->
            <ng-container *ngIf="useVirutalScroll; else noVirtualScroll">
              <cdk-virtual-scroll-viewport
                #scrollViewport
                [itemSize]="44"
                [minBufferPx]="rows?.length"
                [maxBufferPx]="rows?.length"
                class="virtual-scroll-viewport"
                [style.height]="maxHeight"
              >
                <table
                  #table
                  [style.display]="hasSetHeaders ? 'table' : 'none'"
                  [style.width]="tableWidth"
                  [style.min-width]="minWidth"
                  [style.table-layout]="tableLayout"
                  class="app-table"
                  [ngClass]="{
                    'app-table-alternating-rows-enabled': hasAlternatingRows,
                    'app-table-bordered': hasBorders,
                    'app-table-borderless': !hasBorders
                  }"
                >
                  <ng-container
                    *ngTemplateOutlet="tableHeaderTemplate"
                  ></ng-container>

                  <tbody>
                    <tr
                      *cdkVirtualFor="
                        let row of rows;
                        trackBy: trackByFn;
                        index as i
                      "
                      (mousedown)="onRowMouseDown($event)"
                      (click)="handleClickedRow($event, row)"
                      [style.cursor]="clickableRows ? 'pointer' : 'default'"
                      [ngClass]="{ 'table-link-row': !!clickableRows }"
                      [ngStyle]="row?.rowStyles"
                    >
                      <!-- (mousedown)="handleClickedRow($event, row)" -->

                      <ng-container
                        *ngTemplateOutlet="
                          tableRowTemplate;
                          context: { $implicit: row, index: i }
                        "
                      ></ng-container>
                    </tr>
                  </tbody>
                </table>
              </cdk-virtual-scroll-viewport>
            </ng-container>
            <!-- avoid virtual scroll table -->

            <ng-template #noVirtualScroll>
              <!-- [style.width]="'auto'" -->
              <table
                #table
                [style.width]="tableWidth"
                [style.min-width]="minWidth"
                [style.table-layout]="tableLayout"
                class="app-table"
                [ngClass]="{
                  'app-table-alternating-rows-enabled': hasAlternatingRows,
                  'app-table-bordered': hasBorders,
                  'app-table-borderless': !hasBorders
                }"
              >
                <ng-container
                  *ngTemplateOutlet="tableHeaderTemplate"
                ></ng-container>

                <tbody>
                  <ng-container
                    *ngFor="let row of rows; trackBy: trackByFn; index as i"
                  >
                    <tr
                      (click)="handleClickedRow($event, row)"
                      [style.cursor]="clickableRows ? 'pointer' : 'default'"
                      [ngClass]="{ 'table-link-row': !!clickableRows }"
                      [ngStyle]="row?.rowStyles"
                    >
                      <ng-container
                        *ngTemplateOutlet="
                          tableRowTemplate;
                          context: { $implicit: row, i }
                        "
                      ></ng-container>
                    </tr>
                  </ng-container>
                </tbody></table
            ></ng-template>
          </div>
        </div>
      </div>
      <div
        *ngIf="canLoadMore"
        class="load-more-container"
        style="
          padding: 10px 0px 10px 0px;
          display: flex;
          justify-content: center;
        "
      >
        <button
          nbButton
          [disabled]="disableLoadMore"
          (click)="handleLoadMore()"
          class="load-more-button"
        >
          {{ "load_more" | translation }}
        </button>
      </div>
    </ng-template>
  </ng-template>
  <scaffold-paginator
    *ngIf="
      !isLoading &&
      (showPaginator || canSearch) &&
      itemCount &&
      itemCount >= perPage
    "
    [itemCount]="itemCount"
    [(activePage)]="pageNumber"
    [perPage]="perPage"
    (activePageChange)="handleActivePageChange($event)"
  >
  </scaffold-paginator>
</div>

<!--  table header -->
<ng-template #tableHeaderTemplate>
  <thead>
    <tr>
      <th
        [style.top]="inverseOfTranslation"
        *ngIf="showRowCountColumn"
        [style.width]="'40px'"
      ></th>

      <th
        [style.top]="inverseOfTranslation"
        (click)="handleSortChange(column)"
        *ngFor="let column of columns; trackBy: trackByColumn"
        [style.cursor]="column?.isSortable ? 'pointer' : ''"
      >
        <span
          *ngIf="!column.avoidTranslation"
          [style.text-transform]="column.textTransform"
          [ngClass]="{'header-column-checkbox':column?.headerCheckboxValue ||
            column?.headerCheckboxValue === false}"
        >
          <div
            style="display: flex; justify-content: center"
            *ngIf="
              column?.headerCheckboxValue ||
              column?.headerCheckboxValue === false
            "
          >
            <p-checkbox
              binary="true"
              class="background-color-secondary app-table-checkbox"
              [ngModel]="column.headerCheckboxValue"
              [ngModelOptions]="{ standalone: true }"
              (onChange)="handleCheckedColumn(column)"
            ></p-checkbox>
          </div>
          {{
            column?.translationKey || column.text
              | translation
              | translationFromString
              | transformText : column?.textTransform
          }}
          <span
            style="padding-left: 8px"
            *ngIf="column.isSortable && sortBy === column.property"
          >
            <i
              class="fas text-link-color"
              [ngClass]="{
                'fa-caret-down': sortAsc,
                'fa-caret-up': !sortAsc
              }"
            >
            </i>
          </span>
          <span
            style="padding-left: 8px"
            *ngIf="column.isSortable && sortBy !== column.property"
          >
            <i class="fas fa-caret-down"> </i>
          </span>
        </span>

        <span
          *ngIf="column.avoidTranslation"
          [style.text-transform]="column.textTransform"
        >
          <div
            style="display: flex; justify-content: center"
            *ngIf="
              column?.headerCheckboxValue ||
              column?.headerCheckboxValue === false
            "
          >
            <p-checkbox
              binary="true"
              class="background-color-secondary app-table-checkbox"
              [ngModel]="column.headerCheckboxValue"
              [ngModelOptions]="{ standalone: true }"
              (onChange)="handleCheckedColumn(column)"
            ></p-checkbox>
          </div>
          {{
            column?.translationKey || column.text
              | translation
              | translationFromString
              | transformText : column?.textTransform
          }}
          <span
            style="padding-left: 8px"
            *ngIf="column.isSortable && sortBy === column.property"
          >
            <i
              class="fas text-link-color"
              [ngClass]="{
                'fa-caret-down': sortAsc,
                'fa-caret-up': !sortAsc
              }"
            >
            </i>
          </span>
          <span
            style="padding-left: 8px"
            *ngIf="column.isSortable && sortBy !== column.property"
          >
            <i class="fas fa-caret-down"> </i>
          </span>
        </span>
        <!-- left -->
        <!-- <div
          class="app-table-resize-column-left-handle"
          (mousedown)="onColumnMouseDown($event, column)"
        ></div> -->
        <!-- right -->
        <div
          *ngIf="draggable"
          class="app-table-resize-column-right-handle"
          (mousedown)="onColumnMouseDown($event, column)"
        ></div>
      </th>
      <th
        [style.top]="inverseOfTranslation"
        class="app-table-header-actions"
        *ngIf="actions?.length"
        [style.width.px]="actions?.length* 30"
      ></th>
    </tr>
  </thead>
</ng-template>

<!-- table row content -->
<ng-template #tableRowTemplate let-row let-index="index">
  <td *ngIf="showRowCountColumn">
    <div class="app-table-content-wrapper" [style.max-height]="rowMaxHeight">
      {{ index + 1 }}
    </div>
  </td>

  <td
    *ngFor="let column of columns; trackBy: trackByColumn"
    [ngSwitch]="column?.type"
  >
    <!-- avoid content for empty rows -->
    <!-- <ng-container *ngIf="row?.emptyRow; else defaultview"></ng-container> -->
    <!-- <ng-template #defaultview> -->
    <!-- dragable row space -->
    <div
      *ngIf="draggable"
      class="app-table-row-drag-top"
      (mousedown)="onRowMouseDown($event)"
    ></div>
    <!-- <div
      *ngIf="tableLayout !== 'auto'"
      class="app-table-row-drag-left"
      (mousedown)="onRowColumnMouseDown($event, column)"
    ></div> -->
    <div
      *ngIf="tableLayout !== 'auto' && draggable"
      class="app-table-row-drag-right"
      (mousedown)="onRowColumnMouseDown($event, column)"
    ></div>

    <div
      *ngIf="!row?.['_avoid_'+column.property]"
      class="app-table-content-wrapper"
      [style.max-width]="rowMaxWidth"
      [style.max-height]="rowMaxHeight"
    >
      <!-- [style.white-space]="column?.whitespace || 'inherit'" -->

      <!-- start row specific template -->
      <ng-container *ngSwitchCase="'template'">
        <!-- failed attempt, will retry with passing in dynamic templates/components/content passed in from parent component to have more control of what each column/rows display, until then, will just have rows provide the dynamic value for what elements to provide for rather than just the columns setting that... -->

        <ng-container [ngSwitch]="row?.[column?.property]?.viewType">
          <ng-container *ngSwitchCase="'button-link'">
            <span
              (click)="handleColumnRowClicked($event, row, column.property)"
              class="app-table-button-link text-link-color"
            >
              {{row?.[column?.property]?.text}}
            </span>
          </ng-container>

          <ng-container *ngSwitchCase="'locallink'">
            <ng-container
              *ngIf="row?.[column?.property]?.link||row?.[column?.property]?.text; else undefinedValue"
            >
              <a
                [queryParams]="row?.[column?.property]?.queryParams"
                [routerLink]="row?.[column?.property]?.link"
                *ngIf="row?.[column?.property]?.link"
                >{{ row?.[column?.property]?.text }}</a
              >
              <ng-container
                *ngIf="!row?.[column?.property]?.link"
                >{{ row?.[column?.property]?.text ||undefinedText}}</ng-container
              >
            </ng-container>
            <ng-template #undefinedValue>
              <span class="app-table-undefined-content">{{
                undefinedText | translation
              }}</span>
            </ng-template>
          </ng-container>

          <ng-container *ngSwitchCase="'date'">
            <ng-container
              *ngIf="row?.[column?.property]?.value; else undefinedValue"
            >
              {{
row?.[column?.property].value | date : "MMMM d, y"
              }}</ng-container
            >
            <ng-template #undefinedValue>
              <span class="app-table-undefined-content">{{
                undefinedText | translation
              }}</span>
            </ng-template>
          </ng-container>

          <ng-container
            *ngSwitchDefault
            >{{row?.[column?.property]?.text}}</ng-container
          >
        </ng-container>
        <!-- end row specific template -->
      </ng-container>
      <ng-container *ngSwitchCase="'input'">
        <app-input
          style="width: 100%"
          [control]="row?.[column?.property]"
        ></app-input>
      </ng-container>

      <ng-container *ngSwitchCase="'toggle'">
        <div style="display: flex; justify-content: center">
          <app-input-toggle-small
            [pTooltip]="column?.tooltip"
            tooltipPosition="top"
            (changeUpdate)="handleRowInputUpdate($event, 'toggle', row, column)"
            [control]="row?.[column?.property]"
          ></app-input-toggle-small>
        </div>
      </ng-container>
      <ng-container
        *ngSwitchCase="'boolean'"
        >{{row?.[column?.property]? 'Yes':'No'
        }}</ng-container
      >
      <ng-container *ngSwitchCase="'date'">
        
        <ng-container *ngIf="row?.[column?.property]&&row?.[column?.property]!==undefinedText; else undefinedValue">
          {{
row?.[column?.property] | localizeDate : "MMMM d, yyyy"
          }}</ng-container
        >
        <ng-template #undefinedValue>
          <span class="app-table-undefined-content">{{
            column?.undefinedText || undefinedText | translation
          }}</span>
        </ng-template>
      </ng-container>
      <ng-container *ngSwitchCase="'fulldate'">
        <ng-container *ngIf="row?.[column?.property]; else undefinedValue">
          {{ row?.[column?.property] | localizeDate: "MMMM d, y h:mm:ss a" }}
        </ng-container>
        <ng-template #undefinedValue>
          <span class="app-table-undefined-content">{{
            column?.undefinedText || undefinedText | translation
          }}</span>
        </ng-template>
      </ng-container>

      <ng-container *ngSwitchCase="'scaffoldlink'">
        <a
          [style.text-decoration]="'underline'"
          (click)="handleScaffoldLink($event, row, column?.property)"
          [href]="getURL(row)"
          >{{row?.[column?.property]}}</a
        >
      </ng-container>

      <ng-container *ngSwitchCase="'locallink'">
        <ng-container
          *ngIf="row?.[column?.property]?.link||row?.[column?.property]?.text; else undefinedValue"
        >
          <a
            appTextOverflow
            [tooltipEvent]="
    row?.[column?.property]?.isTextOverflowed ? 'hover' : 'noop'
    "
            (overflowed)="row?.[column?.property].isTextOverflowed = $event"
            [pTooltip]="row?.[column?.property]?.text"
            tooltipPosition="top"
            [queryParams]="row?.[column?.property]?.queryParams"
            [routerLink]="row?.[column?.property]?.link"
            *ngIf="row?.[column?.property]?.link"
            style="
              display: inline-block;
              max-width: 100%;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
            "
            >{{ row?.[column?.property]?.text }}</a
          >
          <ng-container
            *ngIf="!row?.[column?.property]?.link"
            >{{ row?.[column?.property]?.text ||column?.undefinedText || undefinedText}}</ng-container
          >
        </ng-container>
        <ng-template #undefinedValue>
          <span class="app-table-undefined-content">{{
            column?.undefinedText || undefinedText | translation
          }}</span>
        </ng-template>
      </ng-container>

      <ng-container *ngSwitchCase="'link'">
        <ng-container
          *ngIf="row?.[column?.property]?.link||row?.[column?.property]?.text; else undefinedValue"
        >
          <a
            *ngIf="row?.[column?.property]?.link&& row?.[column?.property]?.text;else textcontent"
            target="_blank"
            [href]="row?.[column?.property]?.link"
            >{{ row?.[column?.property]?.text||row?.[column?.property]?.link }}
          </a>

          <ng-template #textcontent>
            <span *ngIf="row?.[column?.property]?.text;else nocontent"></span>
            {{ row?.[column?.property]?.text}}

            <ng-template #nocontent>
              <span class="app-table-undefined-content">{{
                column?.undefinedText || undefinedText | translation
              }}</span>
            </ng-template>
          </ng-template>
        </ng-container>
        <ng-template #undefinedValue>
          <span class="app-table-undefined-content">{{
            column?.undefinedText || undefinedText | translation
          }}</span>
        </ng-template>
      </ng-container>

      <ng-container *ngSwitchCase="'checkbox'">
        <div
          style="display: flex; justify-content: center; align-items: center"
        >
          {{ row[header] }}
          <p-checkbox
            binary="true"
            class="background-color-secondary app-table-checkbox"
            [ngModel]="row?.[column?.property]"
            [ngModelOptions]="{ standalone: true }"
            (onChange)="handleCheckedRow(row, column)"
          ></p-checkbox>
        </div>
      </ng-container>

      <ng-container *ngSwitchCase="'textIcon'">
        <ng-container *ngIf="row?.[column?.property];else undefinedConetnt">

        <span
          >{{ row?.[column?.property]?.text ||column?.undefinedText || undefinedText}}</span
        >
        <i
          style="padding-left: 5px"
          *ngIf="row?.[column?.property]?.iconClass"
          [ngClass]="row?.[column?.property]?.iconClass"
          [pTooltip]="row?.[column?.property]?.tooltip"
          class="app-table-inline-icon"
        ></i>
      </ng-container>
      <ng-template #undefinedConetnt>      <span  class="app-table-undefined-content">{{column?.undefinedText || undefinedText}}</span>
      </ng-template>

      </ng-container>
  
      <ng-container *ngSwitchDefault>
        <ng-container
          *ngIf="row?.[column?.property] || row?.[column?.property]===0; else undefinedValue"
        >
          <span
            [ngClass]="column?.getClass ? column?.getClass(row?.[column?.property]) : ''"
            >{{ row?.[column?.property] | showFalsy }}</span
          >
        </ng-container>

        <ng-template #undefinedValue>
          <span class="app-table-undefined-content">{{
            column?.undefinedText || undefinedText | translation
          }}</span>
        </ng-template>
      </ng-container>
      {{row?.[column?.property]?.icon}}
      <i
        *ngIf="row?.[column?.property]?.icon"
        [ngClass]="row?.[column?.property]?.icon?.class"
        [pTooltip]="row?.[column?.property]?.icon?.tooltip"
        class="app-table-inline-icon"
      ></i>
    </div>
    <!-- </ng-template> -->
  </td>

  <td
    [style.border]="hasBorders ? '1px solid #e4e8ed' : 'none'"
    *ngIf="actions?.length && !row?._avoid_actions && !row?.emptyRow"
  >
    <div class="app-table-actions-container">
      <ng-container
        [ngSwitch]="action.type"
        *ngFor="let action of actions; trackBy: trackByAction"
      >
        <ng-container *ngSwitchCase="'duplicate'">
          <p-button
            *ngIf="!row?.avoid_duplicate"
            [pTooltip]="action?.tooltip || action.type | translation"
            tooltipPosition="left"
            [variant]="'text'"
            [severity]="'link'"
            (click)="handleActionClicked($event, action.type, row)"
          >
            <i class="fa-thin fa-copy"></i>
          </p-button>
        </ng-container>
        <ng-container *ngSwitchCase="'edit'">
          <p-button
            [style.visibility]="!row?._avoid_edit ? 'visible' : 'hidden'"
            [pTooltip]="action?.tooltip || action.type | translation"
            tooltipPosition="left"
            [variant]="'text'"
            [severity]="'link'"
            (click)="handleActionClicked($event, action.type, row)"
          >
            <i class="fa-thin fa-pencil-alt"></i>
          </p-button>
        </ng-container>
        <ng-container *ngSwitchCase="'delete'">
          <p-button
            [style.visibility]="!row?.avoid_delete ? 'visible' : 'hidden'"
            [pTooltip]="action?.tooltip || action.type | translation"
            tooltipPosition="left"
            [variant]="'text'"
            [severity]="'link'"
            (click)="handleActionClicked($event, action.type, row)"
          >
            <i class="fa-thin fa-trash-alt"></i>
          </p-button>
        </ng-container>
        <ng-container *ngSwitchCase="'info'">
          <p-button
            [style.visibility]="!row?.avoid_info ? 'visible' : 'hidden'"
            [pTooltip]="action?.tooltip || action.type | translation"
            tooltipPosition="left"
            [variant]="'text'"
            [severity]="'link'"
            (click)="handleActionClicked($event, action.type, row)"
          >
            <i class="fa-thin fa-info-circle"></i>
          </p-button>
        </ng-container>
      </ng-container>
    </div>
  </td>
</ng-template>
